import React, { createContext } from 'react';
import { is } from '../../services';
import clsx from 'clsx';
import { hashClass } from '../../helpers';
import { useTrilogyContext } from '../../context';
export const AccordionContext = createContext({ inverted: false });
/**
 * Accordion Component
 * @param className {string} Additionnal CSS Classes
 * @param boxed {boolean} Boxed Accordion
 * @param children {ReactNode}
 * @param paddingless {boolean} Remove padding for Accordion
 * @param inverted {boolean} Accordion with white background
 */
const Accordion = ({ className, boxed, paddingless, inverted, testId, ...others }) => {
    const { styled } = useTrilogyContext();
    const classes = hashClass(styled, clsx('accordions', boxed && is('boxed'), paddingless && is('paddingless'), className));
    return (React.createElement(AccordionContext.Provider, { value: { inverted: inverted || false } },
        React.createElement("section", { className: classes, ...others, "data-testid": testId })));
};
export default Accordion;
//# sourceMappingURL=Accordion.js.map